import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Bot, Users, Cpu, GitBranch, Play } from 'lucide-react';
import { cn } from '../../../lib/utils';

const getNodeIcon = type => {
  switch (type) {
    case 'start':
      return Play;
    case 'agent':
      return Bot;
    case 'team':
      return Users;
    case 'llm':
      return Cpu;
    case 'condition':
      return GitBranch;
    default:
      return Bot;
  }
};

const getNodeColor = type => {
  switch (type) {
    case 'start':
      return 'bg-primary text-black border-primary';
    case 'agent':
      return 'bg-shell-card text-[#3B82F6] border-[#3B82F6]/50';
    case 'team':
      return 'bg-shell-card text-[#10B981] border-[#10B981]/50';
    case 'llm':
      return 'bg-shell-card text-[#8B5CF6] border-[#8B5CF6]/50';
    case 'condition':
      return 'bg-shell-card text-[#F59E0B] border-[#F59E0B]/50';
    default:
      return 'bg-shell-card text-muted border-white/30';
  }
};

export const WorkflowNode = memo(({ data, selected }) => {
  const nodeType = data.type;
  const nodeLabel = data.label;

  const Icon = getNodeIcon(nodeType);
  const colorClasses = getNodeColor(nodeType);

  return (
    <div
      className={cn(
        'px-4 py-3 rounded-lg border-2 min-w-[180px] shadow-lg transition-all',
        colorClasses,
        selected && 'ring-2 ring-primary ring-offset-2 ring-offset-shell-main',
      )}>
      {nodeType !== 'start' && <Handle type="target" position={Position.Left} className="w-3 h-3 !bg-primary" />}

      <div className="flex items-center gap-2">
        <Icon className="h-5 w-5" />
        <div className="flex-1">
          <div className={cn('font-medium text-sm', nodeType === 'start' ? 'text-black' : 'text-white')}>
            {nodeLabel}
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} className="w-3 h-3 !bg-primary" />
    </div>
  );
});

WorkflowNode.displayName = 'WorkflowNode';
